// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1EbFf","amount":"Amount_amount__3Bi-r","tip":"Amount_tip__2Y3Hd","tipHeader":"Amount_tipHeader__3VYkg","tipsWrap":"Amount_tipsWrap__3tcZe"};